export const checkIfAllArrayItemsAreEqualTo = <T>(array: Array<T>, value: T): boolean => {
    if (!array) {
        return false;
    }

    return array.filter(item => item === value).length === array.length;
};
